/**
 * One ranked leaderboard row: rank · real avatar · name · score. The current user's row is tinted.
 */

import { View, Text } from 'react-native';
import { FriendAvatar } from '../../friends/shared/FriendAvatar';
import { gameLeaderboardSheetStyles as styles } from './GameLeaderboardSheet.styles';
import { GAME_LB_ROW_AVATAR_SIZE, GAME_LB_TEST_IDS } from './GameLeaderboardSheet.constants';
import type { GameLeaderboardEntry } from '../../../src/quiz/helpers/gamesApi';

export function GameLeaderboardRow({ entry }: { entry: GameLeaderboardEntry }) {
  const me = entry.isCurrentUser;
  return (
    <View style={[styles.row, me && styles.rowMe]} testID={GAME_LB_TEST_IDS.row(entry.rank)}>
      <Text style={styles.rowRank}>{entry.rank}</Text>
      <FriendAvatar
        size={GAME_LB_ROW_AVATAR_SIZE}
        avatarId={entry.avatarId}
        avatarConfig={entry.avatarConfig}
        fallbackUrl={entry.avatar ?? undefined}
        nameForInitials={entry.name}
      />
      <Text style={[styles.rowName, me && styles.rowNameMe]} numberOfLines={1}>
        {entry.name}
      </Text>
      <Text style={styles.rowScore}>{entry.score}</Text>
    </View>
  );
}
